import React from "react";

const About = () => {
  return (
    <div className="about">
      {/*<h1>ABOUT TEST</h1>*/}
      <div className="aboutSection">
          <picture>
            <img
                src={process.env.PUBLIC_URL + "/img/photo_about.webp"}
                alt="Photo de l'artiste"
            />
          </picture>
          <div className="aboutSection_text">
            <p>
                Né en 1990 et installé à Montréal depuis 2018, je développe une pratique artistique centrée sur l’encre à alcool, à la croisée de l’abstraction géométrique et de l’art optique.
            <br /><br />
            </p>
            <p>
            Ayant grandi entre un monde encore analogique et l’émergence du numérique, mon langage visuel s’est construit au contact des pixels, des écrans et des structures graphiques qui ont transformé notre perception du réel. 
            Les lignes, répétitions et formes géométriques présentes dans mes œuvres portent l’empreinte de cette transition, tout en dialoguant avec des comportements organiques plus instinctifs et imprévisibles.
                <br /><br />
            </p>
            <p>
                Daltonien, j’entretiens un rapport particulier à la couleur, abordée comme une sensation vivante plutôt qu’une donnée fixe.
                Inspiré par la lumière et les paysages méditerranéens de mon enfance, mon travail explore les notions de perception, d’équilibre et d’adaptation dans un monde en transformation constante.
                <br /><br />
            </p>
            <p>
                Depuis 2023, mes œuvres ont été présentées dans différents contextes culturels et continuent d’évoluer à travers une recherche mêlant expérimentation technique et immersion visuelle.
                <br /><br /><br />
            </p>
            <p>
            Contact : <a className="mail" href="mailto:antoinedevictor.art@gmail.com">antoinedevictor.art@gmail.com</a>
            </p>

          </div>
      </div>
    </div>
  );
};

export default About;